module.exports = __webpack_public_path__ + "media/img/about/person/yunita-367f7c0ee098a3d149829b8bd91f4756.png";